import React, { useState } from "react";
import { Shield, Info, Mail, Phone, Eye } from "lucide-react";

const PrivacyNotice = ({ isVisible, onAccept, onDecline, onShowDetails }) => {
  const [showDetails, setShowDetails] = useState(false);

  if (!isVisible) return null;

  return (
    <div className="privacy-overlay">
      <div className="privacy-notice-card">
        <div className="privacy-header">
          <Shield className="privacy-icon" size={32} />
          <h2>Datenschutzhinweis</h2>
        </div>

        <div className="privacy-content">
          <p className="privacy-intro">
            <strong>Eurosill GmbH</strong> respektiert Ihre Privatsphäre und den Schutz Ihrer personenbezogenen Daten. 
            Mit der Teilnahme an unserer Bestandskundenumfrage willigen Sie in die Verarbeitung Ihrer Daten gemäß DSGVO ein.
          </p>

          <div className="data-collection-info">
            <h3>📋 Welche Daten werden erhoben?</h3>
            <ul>
              <li><strong>Kontaktdaten:</strong> Name, E-Mail-Adresse</li>
              <li><strong>Optional:</strong> Unternehmen, Position, Bestellnummer</li>
              <li><strong>Umfrageantworten:</strong> Bewertungen und Feedback</li>
              <li><strong>Technische Daten:</strong> Zeitstempel der Teilnahme</li>
            </ul>
          </div>

          <div className="data-usage-info">
            <h3>🎯 Verwendungszweck</h3>
            <ul>
              <li>Auswertung der Kundenzufriedenheit</li>
              <li>Verbesserung unserer Produkte und Dienstleistungen</li>
              <li>Interne Qualitätssicherung und Statistiken</li>
              <li>Nachfassung bei Detractors (NPS ≤ 6) für Service-Verbesserung</li>
            </ul>
          </div>

          {showDetails && (
            <div className="privacy-details">
              <div className="data-processing-info">
                <h3>⚖️ Rechtsgrundlage</h3>
                <p>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an Qualitätsverbesserung)</p>

                <h3>🗄️ Speicherdauer</h3>
                <p>Ihre Daten werden für maximal <strong>3 Jahre</strong> gespeichert und anschließend gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.</p>

                <h3>🔒 Datensicherheit</h3>
                <ul>
                  <li>Verschlüsselte Datenübertragung (HTTPS/TLS)</li>
                  <li>Sichere Datenspeicherung in Deutschland/EU</li>
                  <li>Zugriff nur für autorisierte Mitarbeiter</li>
                  <li>Regelmäßige Sicherheitsupdates und -audits</li>
                </ul>

                <h3>👤 Ihre Rechte</h3>
                <ul>
                  <li><strong>Auskunft:</strong> Information über gespeicherte Daten (Art. 15 DSGVO)</li>
                  <li><strong>Berichtigung:</strong> Korrektur falscher Daten (Art. 16 DSGVO)</li>
                  <li><strong>Löschung:</strong> Löschung Ihrer Daten (Art. 17 DSGVO)</li>
                  <li><strong>Einschränkung:</strong> Beschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                  <li><strong>Widerruf:</strong> Einwilligung jederzeit widerrufbar (Art. 7 DSGVO)</li>
                  <li><strong>Beschwerde:</strong> Bei der zuständigen Aufsichtsbehörde</li>
                </ul>

                <h3>📞 Kontakt Datenschutz</h3>
                <div className="contact-info">
                  <p><strong>Verantwortlicher:</strong><br />
                  Eurosill GmbH<br />
                  Datenschutzbeauftragter<br />
                  E-Mail: <a href="mailto:datenschutz@eurosill.com">datenschutz@eurosill.com</a><br />
                  Tel: <a href="tel:+4938746699020">+49 3874 6699020</a></p>

                  <p><strong>Aufsichtsbehörde:</strong><br />
                  Landesbeauftragter für Datenschutz und Informationsfreiheit Mecklenburg-Vorpommern<br />
                  <a href="https://www.datenschutz-mv.de" target="_blank" rel="noopener noreferrer">
                    www.datenschutz-mv.de
                  </a></p>
                </div>
              </div>
            </div>
          )}

          <div className="privacy-toggle">
            <button 
              onClick={() => setShowDetails(!showDetails)}
              className="details-toggle"
            >
              <Eye size={16} />
              {showDetails ? 'Details ausblenden' : 'Vollständige Datenschutzerklärung anzeigen'}
            </button>
          </div>

          <div className="consent-section">
            <div className="consent-text">
              <p><strong>Mit der Teilnahme an der Umfrage stimmen Sie zu:</strong></p>
              <ul className="consent-list">
                <li>✅ Der Erhebung und Verarbeitung der angegebenen Daten</li>
                <li>✅ Der internen Auswertung für Qualitätszwecke</li>
                <li>✅ Einer möglichen Nachfassung bei niedrigen Bewertungen</li>
                <li>✅ Der Speicherung für maximal 3 Jahre</li>
              </ul>
              
              <p className="withdrawal-note">
                <Info size={16} />
                <em>Sie können Ihre Einwilligung jederzeit per E-Mail an 
                <a href="mailto:datenschutz@eurosill.com"> datenschutz@eurosill.com</a> widerrufen.</em>
              </p>
            </div>
          </div>
        </div>

        <div className="privacy-actions">
          <button onClick={onDecline} className="decline-btn">
            Ablehnen
          </button>
          <button onClick={onAccept} className="accept-btn">
            Zustimmen und fortfahren
          </button>
        </div>

        <div className="privacy-footer">
          <p>Stand: {new Date().toLocaleDateString('de-DE')} | DSGVO-konform</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyNotice;